import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { Avatar, Box, IconButton, List, ListItem, ListItemAvatar, ListItemText, Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, LinearProgress, Slide, Tooltip, ListItemButton, AccordionDetails, Accordion, AccordionSummary, InputAdornment, ButtonBase, CircularProgress, Alert, AlertTitle, Chip } from '@mui/material';
import PlayCircleOutlineRoundedIcon from '@mui/icons-material/PlayCircleOutlineRounded';
import Scrollbars from 'react-custom-scrollbars-2';
import CloseIcon from '@mui/icons-material/Close';
import api from '../../../conf/api';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SearchIcon from '@mui/icons-material/Search';
import { toast } from 'react-toastify';
import ChatGPTIcon from "../../../static/icons/chat-gpt.png"
import Autocomplete from '@mui/material/Autocomplete';


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

function VideoPlayerDialog({ open, onClose, video }) {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="md"
            TransitionComponent={Transition}
        >
            <DialogTitle sx={{ pr: 7 }}>
                {video?.title || "Video Player"}
                <IconButton
                    aria-label="Close video player"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <Box
                    sx={{
                        position: 'relative',
                        paddingTop: '56.25%', // 16:9 aspect ratio
                        backgroundColor: '#000',
                    }}
                >
                    {video?.dropbox_link ? (
                        <video
                            src={video.dropbox_link?.replace("www.dropbox.com", "dl.dropboxusercontent.com")}
                            controls
                            style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                            }}
                        >
                            Your browser does not support the video tag.
                        </video>
                    ) : (
                        <Typography
                            variant="h6"
                            color="text.secondary"
                            sx={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                            }}
                        >
                            No video available
                        </Typography>
                    )}
                </Box>
            </DialogContent>
        </Dialog>
    );
}
function VideoDialog({ open, onClose, selectedVideos, user, handleAddVideo }) {
    const [videos, setVideos] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [videoBox, setVideoBox] = React.useState({});
    const [searchText, setSearchText] = React.useState("");

    const fetchVideos = async () => {
        setLoading(true);
        try {
            const formattedFilters = {
                user: user.username,
                dropbox: true,
                search: searchText,
            };

            const res = await api.get("/videos/api", { params: { page: 1, page_size: 1000, not_submited: 1, ...formattedFilters } });
            if (res.status === 200) {
                setVideos(res.data.results);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };
    const handleToggleSelect = (vid) => {
        const isSelected = selectedVideos.some((video) => video.id === vid.id);
        if (!isSelected) {
            handleAddVideo([...selectedVideos, vid]);
        } else {
            handleAddVideo(selectedVideos.filter((video) => video.id !== vid.id));
        }
    };
    // React.useEffect(() => { handleAddVideo(selectedVideos) }, [selectedVideos]);
    React.useEffect(() => {
        const debounceTimeout = setTimeout(() => {
            fetchVideos();
        }, 600);

        return () => clearTimeout(debounceTimeout);

        // eslint-disable-next-line
    }, [searchText, user]);

    return (
        <>
            <Dialog
                TransitionComponent={Transition}
                open={open}
                onClose={() => {
                    onClose();
                    setSearchText("");
                }}
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle>
                    Videos for {user?.first_name} {user?.last_name}
                    <Typography variant="body2" color="text.secondary">
                        {selectedVideos.length} selected · click a row to select, the play icon to preview
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <TextField
                        fullWidth
                        autoFocus
                        size="small"
                        label="Search videos"
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        sx={{ mb: 2, mt: 0.5 }}
                        InputProps={{ startAdornment: (<InputAdornment position="start"><SearchIcon fontSize="small" /></InputAdornment>) }}
                    />
                    {loading ? <LinearProgress aria-label="Loading videos" /> :
                        <Box>
                            <Scrollbars style={{ height: 300 }}>
                                <List sx={{
                                    "& .Mui-selected": {
                                        bgcolor: (theme) => `${theme.palette.primary.main}22 !important`,
                                    },
                                    "& .MuiListItemButton-root:hover": {
                                        "&:hover": {
                                            backgroundColor: (theme) => `${theme.palette.primary.main}33 !important`
                                        }
                                    },

                                }}>
                                    {videos.map((item) => (
                                        <ListItemButton
                                            key={item.id}
                                            onClick={() => handleToggleSelect(item)}
                                            selected={selectedVideos.some((video) => video.id === item.id)}
                                        >
                                            <Tooltip title={"Preview video"} placement="top" arrow>
                                                <ListItemAvatar
                                                    role="button"
                                                    aria-label={`Preview ${item.title}`}
                                                    sx={{ cursor: "pointer" }}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        setVideoBox(item);
                                                    }}
                                                >
                                                    <Avatar>
                                                        <PlayCircleOutlineRoundedIcon color='primary' />
                                                    </Avatar>
                                                </ListItemAvatar>
                                            </Tooltip>
                                            <ListItemText
                                                primary={`${item.title}`}
                                                secondary={`(${item.assert_id})-${new Date(item.created_date).toLocaleString()}`}
                                            />
                                        </ListItemButton>
                                    ))}
                                </List>
                            </Scrollbars>
                        </Box>
                    }
                    <Box>
                        {!loading && videos.length === 0 && (

                            <Typography variant="body1" color="text.secondary" sx={{ py: 2 }}>No videos found for this creator.</Typography>

                        )}
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => {
                        setSearchText("");
                        onClose();
                    }} variant="contained">Done</Button>
                </DialogActions>
            </Dialog>
            <VideoPlayerDialog
                open={videoBox && Object.keys(videoBox).length > 0}
                onClose={() => setVideoBox(null)}
                video={videoBox}
            />
        </>
    );
}

export default function ActionAreaCard({ user, categories, onRemove, compilationData, setCompilationData, showLoader = () => { } }) {
    const [open, setOpen] = React.useState(false);

    const [loading, setLoading] = React.useState(false);
    const [formExpanded, setFormExpanded] = React.useState(true)

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const handleRemove = () => {
        setCompilationData(pre => {
            let preData = { ...pre };
            delete preData[user?.id];
            return preData
        })
        onRemove(user);
    }

    const handleAddVideo = (vids) => {
        setCompilationData((prev) => ({
            ...prev,
            [user?.id]: {
                ...prev[user?.id],
                videos: vids,
                errors: [],
            }
        }));
    };

    const EnhanceText = async (text) => {
        try {
            showLoader(true);
            setLoading(true);
            const res = await api.post("videos/enhance-text/", { text });

            let { title, description, tags } = res.data;

            // Convert comma-separated tags into trimmed array
            let tagsArray = [];
            if (typeof tags === "string") {
                tagsArray = tags.split(",").map(tag => tag.trim()).filter(tag => tag);
            } else if (Array.isArray(tags)) {
                tagsArray = tags;
            }
            return [title, description, tagsArray];
        } catch (error) {
            console.error("Error in enhancing text:", error);
            toast.error("Error in enhancing text");
            return [null, null, []];
        } finally {
            setLoading(false);
             showLoader(false);
        }
    };

    const handleAutoFill = () => {
        if (compilationData[user?.id]?.videos?.length === 0) {
            toast.error("Please select a video first");
            return;
        } else {
            let title = "";
            for (const vid of compilationData[user?.id]?.videos) {
                title += vid.title + "\n";
            }
            EnhanceText(title).then((res) => {
                if (res) {
                    setCompilationData((prev) => ({
                        ...prev,
                        [user?.id]: {
                            ...prev[user?.id],
                            question4: res[1],
                            video_title: res[0],
                            tags: res[2],
                            errors: [],
                        }
                    }));
                }
            });


        }
    }
    const is_valid = compilationData?.[user?.id]?.errors?.length === 0 ? true : false;
    return (
        <>
            <Card variant="outlined" sx={{ width: '100%', borderColor: !is_valid ? 'error.main' : 'divider', borderWidth: !is_valid ? 2 : 1 }}>
                <Box>
                    <CardContent>
                        {!is_valid &&
                            <Alert severity="error" role="alert" sx={{ mb: 2 }}>
                                <AlertTitle>Fix before submitting</AlertTitle>
                                <Box component="ul" sx={{ m: 0, pl: 2 }}>
                                    {compilationData[user?.id]?.errors?.map((e) => <li key={e}>{e}</li>)}
                                </Box>
                            </Alert>
                        }
                        <Box display="flex" alignItems="center" justifyContent="space-between">
                            <Typography variant="h6" component="h3" fontWeight={600}>
                                {user?.first_name} {user?.last_name}
                            </Typography>
                            <IconButton
                                aria-label={`Remove ${user?.first_name} ${user?.last_name}`}
                                disabled={loading}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleRemove();
                                }}>
                                <CloseIcon />
                            </IconButton>
                        </Box>
                        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                            {user?.username}
                            <br />
                            {user?.email}
                        </Typography>
                        <Box display="flex" alignItems="center" gap={1} mt={2}>
                            <Typography variant='subtitle1' fontWeight={600}>Selected videos</Typography>
                            <Chip size="small" label={compilationData[user?.id]?.videos?.length || 0} />
                        </Box>
                        <Box
                            component={ButtonBase}
                            onClick={handleOpen}
                            aria-label={`Choose videos for ${user?.first_name} ${user?.last_name}`}
                            sx={{ border: '1px dashed', borderColor: 'divider', borderRadius: 2, p: 1, width: '100%', display: 'flex', textAlign: 'left', '&:hover': { bgcolor: 'action.hover' }, '&:focus-visible': { outline: '2px solid', outlineColor: 'primary.main' } }}
                        >
                            <Scrollbars style={{ height: compilationData[user?.id]?.videos?.length === 0 ? 90 : 200 }}>
                                <List dense sx={{ padding: 0 }}>
                                    {compilationData[user?.id]?.videos?.map((item) => (
                                        <ListItem key={item.id}>
                                            <ListItemAvatar>
                                                <Avatar>
                                                    <PlayCircleOutlineRoundedIcon fontSize='small' color='primary' />
                                                </Avatar>
                                            </ListItemAvatar>
                                            <ListItemText primary={`${item.title}`} secondary={`(${item.assert_id}) ${new Date(item.created_date).toLocaleString()}`} />
                                        </ListItem>
                                    ))}
                                    {compilationData[user?.id]?.videos?.length === 0 && (
                                        <ListItem>
                                            <ListItemText primary="No videos added" secondary="Select to choose this creator's videos" />
                                        </ListItem>
                                    )}
                                </List>
                            </Scrollbars>
                        </Box>
                        <Box mt={2}>
                            <Accordion expanded={formExpanded} onChange={() => setFormExpanded(!formExpanded)} >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    id="video_details-header"
                                    onClick={e => e.stopPropagation()}
                                >
                                    <Box display="flex" alignItems="center">
                                        <Tooltip title="Auto fill" placement="top" arrow>
                                            <IconButton
                                                color='primary'
                                                aria-label="Auto-fill details with AI"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    setFormExpanded(true);
                                                    handleAutoFill();
                                                }}>
                                                {loading ?
                                                    <CircularProgress size={23} />
                                                    :
                                                    <Box component="img" src={ChatGPTIcon} width={25} />
                                                }
                                            </IconButton>
                                        </Tooltip>
                                        <Typography component="span" fontWeight={600}>Video information</Typography>
                                    </Box>
                                </AccordionSummary>
                                <AccordionDetails sx={{ pt: 0, mt: -2 }}>
                                    <Box component="form" noValidate autoComplete="off">
                                        <TextField
                                            disabled={loading}
                                            value={compilationData?.[user?.id]?.video_title || ""}
                                            onChange={(e) => setCompilationData((prev) => ({ ...prev, [user?.id]: { ...prev[user?.id], video_title: e.target.value } }))}
                                            fullWidth
                                            label="Video title"
                                            name="video_title"
                                            required
                                            variant="outlined"
                                            margin="dense"
                                            size='small'
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="start">
                                                        {loading && <CircularProgress size={20} />}
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                        <TextField
                                            disabled={loading}
                                            value={compilationData?.[user?.id]?.question4 || ""}
                                            onChange={(e) => setCompilationData((prev) => ({ ...prev, [user?.id]: { ...prev[user?.id], question4: e.target.value } }))}
                                            multiline
                                            fullWidth
                                            minRows={3} required label="Background story / context" helperText="Tell the story behind the video: who, where, what happened."
                                            name="question4"
                                            margin="dense"
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="start">
                                                        {loading && <CircularProgress size={20} />}
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                        <Autocomplete
                                            options={categories}
                                            getOptionLabel={(option) => option.title}
                                            value={compilationData?.[user?.id]?.category || null}
                                            onChange={(event, newValue) => {
                                                setCompilationData((prev) => ({
                                                    ...prev,
                                                    [user?.id]: {
                                                        ...prev[user?.id],
                                                        category: newValue,
                                                    },
                                                }));
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Category"
                                                    required
                                                    placeholder="Choose a category"
                                                    variant="outlined"
                                                    margin="dense"
                                                    size="small"

                                                />
                                            )}
                                            isOptionEqualToValue={(option, value) => option.id === value.id}
                                        />
                                        <Autocomplete
                                            multiple
                                            freeSolo
                                            options={[]}
                                            value={compilationData?.[user?.id]?.tags || []}
                                            onChange={(event, newValue) => {

                                                setCompilationData((prev) => ({
                                                    ...prev,
                                                    [user?.id]: {
                                                        ...prev[user?.id],
                                                        tags: newValue,
                                                    },
                                                }));
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Tags"
                                                    required
                                                    helperText="Type a tag and press Enter"
                                                    placeholder="e.g. funny, animals"
                                                    variant="outlined"
                                                    margin="dense"
                                                    size="small"
                                                    InputProps={{
                                                        endAdornment: (
                                                            <InputAdornment position="start">
                                                                {loading && <CircularProgress size={20} />}
                                                            </InputAdornment>
                                                        ),
                                                        ...params.InputProps,
                                                    }}
                                                />
                                            )}
                                        />
                                    </Box>
                                </AccordionDetails>
                            </Accordion>

                        </Box>

                    </CardContent>
                </Box>
            </Card >

            <VideoDialog
                open={open}
                onClose={handleClose}
                user={user}
                selectedVideos={compilationData[user?.id]?.videos || []}
                handleAddVideo={handleAddVideo}
            />
        </>
    );
}